"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const legalLinks = [{
  label: "Terms of Service",
  href: "#"
}, {
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Dsiclaimers",
  href: "#"
}];
const socialLinks = [{
  label: "X (Twitter)",
  href: "#"
}, {
  label: "LinkedIn",
  href: "https://www.linkedin.com/in/garystrahle/"
}];
const contactInfo = [{
  label: "HQ",
  value: "701 South Carson St #200, Carson City, NV 89701",
  isLink: false
}, {
  label: "Email",
  value: "contact@tidalswing.ai",
  isLink: true,
  href: "mailto:contact@tidalswingai.com"
}];
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      id: "fallback-1",
      label: "Intelligence",
      href: "/IntelligencePage"
    }, {
      id: "fallback-2",
      label: "Systems",
      href: "/SystemsPage"
    }, {
      id: "fallback-3",
      label: "Insights",
      href: "/InsightsPage"
    }];
    return <ul className="flex flex-col gap-3">
        {fallbackLinks.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto text-xs">
        
        <div className="w-full mb-12">
          <Link to="/" className="inline-block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/image_unosbtxi.png" alt="Tidal Swing AI Logo" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-5 tracking-wider uppercase">Pages</h3>
            <MenuProvider menu_id="51">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-5 tracking-wider uppercase">
              Legal
            </h3>
            <ul className="flex flex-col gap-3">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-5 tracking-wider uppercase">
              Contact
            </h3>
            <ul className="flex flex-col gap-3">
              {contactInfo.map((info, i) => <li key={info.label} data-index={i} className="text-muted-foreground flex flex-col gap-1">
                  <span className="text-foreground/60">{info.label}</span>
                  {info.isLink ? <Link to={info.href || "#"} className="hover:text-foreground transition-colors duration-200">
                      {info.value}
                    </Link> : <span>{info.value}</span>}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-5 tracking-wider uppercase">
              Social
            </h3>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-foreground transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="mb-8 bg-border/50" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} Tidal Swing AI. All rights reserved.
          </p>
          <Badge variant="outline" className="text-[10px] uppercase tracking-widest border-border text-muted-foreground bg-transparent">
            Powered by Tidal Swing
          </Badge>
        </div>
      </div>
    </section>;
}